export default {"src":"/_next/static/media/magic-stick.93190820.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};